import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { getConsultDetail as getConsultDetailAPI } from '@/api/workPlace/workOrder'

export default function useWorkOrder() {
  const store = useStore()
  //是否是导购咨询
  const isGuideConsult = computed(() => store.state.workOrder.isGuideConsult)
  //当前工单信息
  const curGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
  //工单组信息
  const workOrderGroupInfo = ref({})
  //工单类型
  const curWorkOrderType = computed(() => workOrderGroupInfo.value.targetWorkOrder?.businessType)
  // 问诊详情
  const consultDetail = ref({})
  //是否展示剩余条数
  const showRemainTimes = computed(() => {
    const { free, remainTimes, consultStatus } = consultDetail.value || {}
    return free === 1 && remainTimes >= 0 && consultStatus === 1
  })
  // 剩余问诊次数
  const remainTimes = computed(() => {
    const detail = consultDetail.value || {}
    return detail.remainTimes
  })
  // 获取问诊详情
  const getConsultDetail = async groupInfo => {
    const { consultInfo } = groupInfo || curGroupInfo.value || {}
    const { consultId } = consultInfo || {}
    if (!consultId) return
    try {
      const res = await getConsultDetailAPI({ consultId })
      consultDetail.value = res || {}
    } catch (error) {
      console.error('获取问诊详情失败', error)
    }
  }
  return {
    isGuideConsult,
    workOrderGroupInfo,
    curGroupInfo,
    curWorkOrderType,
    remainTimes,
    consultDetail,
    showRemainTimes,
    getConsultDetail
  }
}
